// extracted by mini-css-extract-plugin
module.exports = {"div":"WelcomeCard_div_3_1X5"};